/* src/app/modules/user/mandate/mandate.component.css */
/*# sourceMappingURL=mandate.component.css.map */
